import React from 'react';
import Modal from '../../../../components/Modal';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  termsType?: 'external' | 'internal';
  termsContent?: string;
  wheelName: string;
}

const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  onClose,
  termsType,
  termsContent,
  wheelName
}) => {
  if (!termsType || !termsContent) {
    return null;
  }

  // Se for link externo, abrir em nova aba ao invés de modal
  if (termsType === 'external') {
    if (isOpen && termsContent) {
      window.open(termsContent, '_blank', 'noopener,noreferrer');
      onClose();
    }
    return null;
  }

  // Modal para regulamento interno (WYSIWYG)
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Regulamento - ${wheelName}`}
      size="lg"
    >
      <div className="prose prose-sm max-w-none">
        <div
          className="text-gray-700"
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
      </div>

      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default TermsModal;
